export default __webpack_public_path__ + "static/media/button-AR-Off.d1433b46.png";